// export default {
//   notfound: "/assets/images/404.svg",
//   logo: "/vercel.svg",
//   logo_img: "/assets/images/logo_img.png",
//   noimage: "/assets/images/logo_img.png"
// };
export default {
    noUser: "/assets/images/profile_img.svg",
    userPlaceholder: "/assets/images/user-placeholder.svg",
    notfound: "/assets/images/404.svg",
    logo: "/vercel.svg",
    logo_img: "/assets/images/logo_img.png",
    noimage: "/assets/images/logo_img.png",
    mainLogo: "/assets/images/main_logo.png",
    selectDropDown: "/assets/images/customselectdropdown.svg",
    testicon: "/assets/icons/2082.png",
    testicon1: "/assets/icons/icon-192x192.png",
    testicon2: "/assets/icons/icon-256x256.png",
    testicon3: "/assets/icons/icon-384x384.png",
    testicon4: "/assets/icons/icon-512x512.png",
    image: "/assets/icons/auricular-phone_318-1028.webp",
    logo: "/assets/images/logo.svg",
    searchicon: "/assets/images/search_icon.svg",
    mail: "/assets/images/mail.svg",
    notification: "/assets/images/notification.svg",
    profileimg: "/assets/images/profile_img.svg",
    menuicon1: "/assets/images/menu_icon1.svg",
    menuicon2: "/assets/images/menu_icon33.svg",
    menuicon3: "/assets/images/menu_icon44.svg",
    menuicon4: "/assets/images/icon-partner.svg",
    menuicon5: "/assets/images/menu_icon5.svg",
    menuicon6: "/assets/images/menu_icon6.svg",
    menuicon7: "/assets/images/menu_icon7.svg",
    menuicon8: "/assets/images/menu_icon8.svg",
    menuicon9: "/assets/images/menu_icon9.svg",
    menuicon10: "/assets/images/menu_icon10.svg",
    menuicon11: "/assets/images/menu_icon11.svg",
    menuicon12: "/assets/images/menu_icon12.svg",
    menuicon13: "/assets/images/menu_icon13.svg",
    menuicon14: "/assets/images/menu_icon14.svg",
    menuicon15: "/assets/images/menu_icon15.svg",
    menuicon16: "/assets/images/menu_icon16.svg",
    smi1: "/assets/images/smi1.svg",
    ExpandArr: "/assets/images/expandArr.svg",
    calanderIconBlue: "/assets/images/calanderIconBlue.svg",
    dashboardconfirmarw: "/assets/images/dashboard_confirm_arw.svg",
    tablefilter: "/assets/images/table-filter.svg",
    arrowIcon: "/assets/images/arrowIcon.svg",
    tableview: "/assets/images/table_view.svg",
    tabthumbnail1: "/assets/images/tab_thumbnail_1.jpg",
    tabthumbnail2: "/assets/images/tab_thumbnail_2.jpg",
    tabthumbnail3: "/assets/images/tab_thumbnail_3.jpg",
    tabthumbnail4: "/assets/images/tab_thumbnail_4.jpg",
    tabthumbnail5: "/assets/images/tab_thumbnail_5.jpg",
    tabthumbnail6: "/assets/images/tab_thumbnail_6.jpg",
    tabthumbnail7: "/assets/images/tab_thumbnail_7.jpg",
    tabthumbnail8: "/assets/images/tab_thumbnail_8.jpg",
    tabthumbnail9: "/assets/images/tab_thumbnail_9.jpg",
    tabthumbnail10: "/assets/images/tab_thumbnail_10.jpg",
    tabthumbnail11: "/assets/images/tab_thumbnail_11.jpg",
    tabthumbnail12: "/assets/images/tab_thumbnail_12.jpg",
    tabthumbnail13: "/assets/images/tab_thumbnail_13.jpg",
    tabthumbnail14: "/assets/images/tab_thumbnail_14.jpg",
    tabthumbnail15: "/assets/images/tab_thumbnail_15.jpg",
    tabthumbnail16: "/assets/images/tab_thumbnail_16.jpg",
    tabthumbnail17: "/assets/images/tab_thumbnail_17.jpg",
    tabthumbnail18: "/assets/images/tab_thumbnail_18.jpg",
    tabthumbnail19: "/assets/images/tab_thumbnail_19.jpg",
    tabthumbnail20: "/assets/images/tab_thumbnail_20.jpg",
    downArrow: "/assets/images/downArrow.svg",
    profileIcon: "/assets/images/profileIcon.svg",
    rightArrow: "/assets/images/rightArrow.svg",
    upArrow: "/assets/images/upArrow.svg",
    member: "/assets/images/member.svg",
    partner: "/assets/images/partner.svg",
    content_buyers: "/assets/images/content_buyers.svg",
    plusicon: "/assets/images/plus_icon.svg",
    mynusicon: "/assets/images/mynus_icon.svg",
    userimg: "/assets/images/user_img.svg",
    partner1: "/assets/images/partner1.svg",
    partner2: "/assets/images/partner2.svg",
    partner3: "/assets/images/partner3.svg",
    loadbar: "/assets/images/loadbar.svg",
    logo_loader: "/assets/images/logo_loader.gif",
    unreachable: "/assets/images/unreachable.svg",
    excla: "/assets/images/excla.svg",
    biggallery: "/assets/images/big_gallery.svg",
    modalicon: "/assets/images/modal_icon.svg",
    video: "/assets/images/mov_bbb.mp4",
    calendar_black: "/assets/images/calendar_black.svg",
    filterIconBlack: "/assets/images/filterIconBlack.svg",
    resetIcon: "/assets/images/resetIcon.svg",
    resetIconBlue: "/assets/images/resetIconBlue.svg",
    purpleArrowIcon: "/assets/images/purpleArrowIcon.svg",
    infoicon: "/assets/images/!icon.svg",
    duplicateIcon: "/assets/images/duplicateIcon.svg",
    globalIcon: "/assets/images/globalIcon.svg",
    allPlatfromIcon: "/assets/images/allPlatfromIcon.svg",
    pendingIcon: "/assets/images/pendingIcon.svg",
    iconSuccess: "/assets/images/icon-success.svg",
    iconLock: "/assets/images/icon-lock.svg",
    iconLockLg: "/assets/images/icon-lg-lock.svg",
    Iconpending: "/assets/images/icon-pending.svg",
    Iconinquiring: "/assets/images/icon-inquiring.svg",
    Iconapprove: "/assets/images/icon-approve.svg",
    Iconwebsite: "/assets/images/icon-website.svg",
    Iconduplication: "/assets/images/icon-duplication.svg",
    Iconreject: "/assets/images/icon-reject.svg",
    Icondelete: "/assets/images/icon-delete.svg",
    publishedicon: "/assets/images/publishedicon.svg",
    pendingPublicationIcon: "/assets/images/pendingPublicationIcon.svg",
    pendingTitlingIcon: "/assets/images/pendingTitlingIcon.svg",
    supportIcon: "/assets/images/supportIcon.svg",
    messageIcon: "/assets/images/messageIcon.svg",
    hubIcon: "/assets/images/hubIcon.svg",
    myAccountIcon: "/assets/images/myAccountIcon.svg",
    copyIcon: "/assets/images/copyIcon.svg",
    websiteIcon: "/assets/images/websiteIcon.svg",
    postIcon: "/assets/images/postIcon.svg",
    messageContentIcon: "/assets/images/messageContentIcon.svg",
    cancelIcon: "/assets/images/cancelIcon.svg",
    Search01: "/assets/images/s01.jpg",
    Magnifying: "/assets/images/icon-magnifying.svg",
    downloadAssignment: "/assets/images/downloadAssignment.svg",
    doenloadVideoicon: "/assets/images/doenloadVideoicon.svg",
    crossWhite: "/assets/images/crossWhite.svg",
    crossBlack: "/assets/images/crossBlack.svg",
    Iconedit: "/assets/images/icon-edit.svg",
    noImg: "/assets/images/no-image.svg",
    Iconcaution: "/assets/images/icon-caution.svg",
    Icongrid: "/assets/images/icon-grid.svg",
    user01: "/assets/images/user01.jpg",
    user02: "/assets/images/user02.svg",
    user03: "/assets/images/user03.jpg",
    user05: "/assets/images/user05.png",
    user06: "/assets/images/user06.png",
    selectDropDown: "/assets/images/selectDropDown.svg",
    IconMessage: "/assets/images/icon-message.svg",
    IconSupport: "/assets/images/icon-support.svg",
    pdfFileIcon: "/assets/images/pdfFileIcon.svg",
    pdfViewIcon: "/assets/images/pdfViewIcon.svg",
    downloadIcon: "/assets/images/downloadIcon.svg",
    socialMediaIcon: "/assets/images/socialMediaIcon.svg",
    videoFileIcon: "/assets/images/videoFileIcon.svg",
    IconCalendar: "/assets/images/icon-calendar.svg",
    IconView: "/assets/images/icon-view.svg",
    purchaseAgreement: "/assets/images/purchaseAgreement.svg",
    noteIcon: "/assets/images/noteIcon.svg",
    accordianMinus: "/assets/images/accordianMinus.svg",
    accordianPlus: "/assets/images/accordianPlus.svg",
    downloadBlueArrow: "/assets/images/downloadBlueArrow.svg",
    crossGray: "/assets/images/crossGray.svg",
    msgImg01: "/assets/images/msg-img01.png",
    IconDwnarw: "/assets/images/icon-dwnarw.svg",
    attachIcon: "/assets/images/attachIcon.svg",
    messageProfileIcon: "/assets/images/messageProfileIcon.svg",
    IconExclamatory: "/assets/images/icon-exclamatory.svg",
    IconNofile: "/assets/images/icon-nofile.svg",
    deleteIcon: "/assets/images/deleteIcon.svg",
    crossBlackIcon: "/assets/images/crossBlackIcon.svg",
    inqureIcon: "/assets/images/inqureIcon.svg",
    signatureImg: "/assets/images/signatureImg.png",
    accordianDateIcon: "/assets/images/accordianDateIcon.svg",
    eyeIcon: "/assets/images/eyeIcon.svg",
    cancelIconBlack: "/assets/images/cancelIconBlack.svg",
    editicon: "/assets/images/editicon.svg",
    noteEyeIcon: "/assets/images/noteEyeIcon.svg",
    noteDeleteIcon: "/assets/images/noteDeleteIcon.svg",
    noteDateIcon: "/assets/images/noteDateIcon.svg",
    iconCross: "/assets/images/icon-cross.svg",
    msgReminder: "/assets/images/msg-reminder.svg",
    msgQc: "/assets/images/msg-qc.svg",
    msgResolve: "/assets/images/msg-resolve.svg",
    msgReopen: "/assets/images/msg-reopen.svg",
    msgEditor: "/assets/images/msg-editor.svg",
    managerOpen: "/assets/images/manager-open.svg",
    managerReopen: "/assets/images/manager-reopen.svg",
    managerResolve: "/assets/images/manager-resolve.svg",
    managerRespond: "/assets/images/manager-respond.svg",
    calenderArrowPrev: "/assets/images/calenderArrowPrev.svg",
    calenderArrowNext: "/assets/images/calenderArrowNext.svg",
    redRefreshIcon: "/assets/images/redRefreshIcon.svg",
    redEditIcon: "/assets/images/redEditIcon.svg",
    fileSaveIcon: "/assets/images/fileSaveIcon.svg",
    sendProductIcon: "/assets/images/sendProductIcon.svg",
    minusIconRed: "/assets/images/minusIconRed.svg",
    plusIconRed: "/assets/images/plusIconRed.svg",
    purpleEditIcon: "/assets/images/purpleEditIcon.svg",
    purpleRefreshIcon: "/assets/images/purpleRefreshIcon.svg",
    IconTrash: "/assets/images/icon-trash.svg",
    IconAddfile: "/assets/images/icon-addfile.svg",
    IconcrossRound: "/assets/images/icon-cross-round.svg",
    zoomIcon: "/assets/images/zoomIcon.svg",
    settingIcon: "/assets/images/settingIcon.svg",
    speakerIcon: "/assets/images/speakerIcon.svg",
    nextButtonIcon: "/assets/images/nextButtonIcon.svg",
    playButtonIcon: "/assets/images/playButtonIcon.svg",
    crossIconBlack: "/assets/images/crossIconBlack.svg",
    rightIconBlack: "/assets/images/rightIconBlack.svg",
    plusIconBlack: "/assets/images/plusIconBlack.svg",
    toolTipIcon: "/assets/images/toolTipIcon.svg",
    expandParaIcon: "/assets/images/expandParaIcon.svg",
    icongraySearch: "/assets/images/icon-gray-search.svg",
    icongrayCross: "/assets/images/icon-sm-cross.svg",
    Notiuserbatch: "/assets/images/noti-userbatch.svg",
    Notiattach: "/assets/images/noti-attach.svg",
    Notibuyer: "/assets/images/noti-buyer.svg",
    Noticheck: "/assets/images/noti-check.svg",
    Noticopy: "/assets/images/noti-copy.svg",
    Noticopywritter: "/assets/images/noti-copywritter.svg",
    Noticross: "/assets/images/noti-cross.svg",
    Notidoubleuser: "/assets/images/noti-doubleuser.svg",
    Notieditor: "/assets/images/noti-editor.svg",
    Notiglobe: "/assets/images/noti-globe.svg",
    Notimoreuser: "/assets/images/noti-moreuser.svg",
    Notiusernote: "/assets/images/noti-usernote.svg",
    Notiusersetting: "/assets/images/noti-usersetting.svg",
    Notivideo: "/assets/images/noti-video.svg",
    Notivideocut: "/assets/images/noti-videocut.svg",
    Notitipalti: "/assets/images/noti-tipalti.png",
    videoImage: "/assets/images/videoImage.png",
    pauseButtonIcon: "/assets/images/pauseButtonIcon.png",
    approveIconGreen: "/assets/images/approveIconGreen.svg",
    approveIconBlack: "/assets/images/approveIconBlack.svg",
    crossIconGray: "/assets/images/crossIconGray.svg",
    lgDoubleTick: "/assets/images/doubletick-large.svg",
    noArchive: "/assets/images/no-archive.svg",
    alertIcon: "/assets/images/alertIcon.svg",
    approveArrow: "/assets/images/approveArrow.svg",
    arrowBoxicon: "/assets/images/arrowBoxicon.svg",
    copyIconBlue: "/assets/images/copyIconBlue.svg",
    exclamatoryIconBlack: "/assets/images/exclamatoryIconBlack.svg",
    iconOops: "/assets/images/icon-oops.svg",
    iconLgbluetick: "/assets/images/icon-bluetick.svg",
    EditorNoitem: "/assets/images/editor-noitem.svg",
    CopywritterNoitem: "/assets/images/copywritter-noitem.svg",
    inquiryIcon: "/assets/images/inquiryIcon.svg",
    deleteBlackIcon: "/assets/images/deleteBlackIcon.svg",
    crossRoundIcon: "/assets/images/crossRoundIcon.svg",
    emptyImg: "/assets/images/emptyImg.svg",
    noresultImg: "/assets/images/noresultImg.svg",
    vsMain: "/assets/images/vs-main.png",
    crossIconPDF: "/assets/images/crossIconPDF.svg",
    searchIcon: "/assets/images/searchIcon.svg",
    fileIcon: "/assets/images/fileIcon.svg",
    releaseVideoIcon: "/assets/images/releaseVideoIcon.svg",
    roundRing: "/assets/images/round-ring.svg",
    tipalti: "/assets/images/logo-tipalti.png",
    copyRighticon: "/assets/images/copyRighticon.svg",
    somethingElseIcon: "/assets/images/somethingElseIcon.svg",
    videoReleaseAssetsImg: "/assets/images/videoReleaseAssetsImg.jpg",
    calenderBlack: "/assets/images/calenderBlack.svg",
    deleteIconRelease: "/assets/images/deleteIconRelease.svg",
    downloadArrowIcon: "/assets/images/downloadArrowIcon.svg",
    partnerCardImg: "/assets/images/partnerCardImg.png",
    partnerCardImg2: "/assets/images/partnerCardImg2.png",
    partnerCardImg1: "/assets/images/partnerCardImg1.png",
    partnerDuplicateIcon: "/assets/images/partnerDuplicateIcon.svg",
    partnerRejectIcon: "/assets/images/partnerRejectIcon.svg",
    partnerApproveIcon: "/assets/images/partnerApproveIcon.svg",
    partnerSubmissionIcon: "/assets/images/partnerSubmissionIcon.svg",
    partnerAddImg: "/assets/images/partnerAddImg.svg",
    partnerRightIcon: "/assets/images/partnerRightIcon.svg",
    purchaseReqstIcon: "/assets/images/purchase-request.svg",
    submissionSummeryImg: "/assets/images/submissionSummeryImg.svg",
    earningImg: "/assets/images/earningImg.svg",
    iconConfirm: "/assets/images/icon-confirm.svg",
    iconDenied: "/assets/images/icon-denied.svg",
    paidBonusIcon: "/assets/images/paidBonusIcon.svg",
    qcagentNoitem: "/assets/images/qcagent-noitems.svg",
    downloadReportIcon: "/assets/images/downloadReportIcon.svg",
    bonusModalImg: "/assets/images/bonusModalImg.svg",
    replaceIcon: "/assets/images/replaceIcon.svg",
    saveIcon: "/assets/images/saveIcon.svg",
    crossIconWhite: "/assets/images/crossIconWhite.svg",
    memberImg: "/assets/images/memberImg.svg",
    memberProfileImg: "/assets/images/memberProfileImg.png",
    contentBuyerImg: "/assets/images/contentBuyerImg.svg",
    websiteonlyChartImg: "/assets/images/websiteonlyChartImg.svg",
    allPlatfromChartImg: "/assets/images/allPlatfromChartImg.svg",
    allSubmissionChartImg: "/assets/images/allSubmissionChartImg.png",
    smileIcon: "/assets/images/icon-smile.svg",
    managerNoitem: "/assets/images/manager-noitems.svg",
    paymentHistoryImg: "/assets/images/paymentHistoryImg.svg",
    eyeBlueIcon: "/assets/images/eyeBlueIcon.svg",
    deleteRedIcon: "/assets/images/deleteRedIcon.svg",
    memberIconExpenses: "/assets/images/memberIconExpenses.svg",
    contentBuyerIconExpenses: "/assets/images/contentBuyerIconExpenses.svg",
    partnerIconExpenses: "/assets/images/partnerIconExpenses.svg",
    eyeIconBlack: "/assets/images/eyeIconBlack.svg",
    accountingIcon: "/assets/images/accountingIcon.svg",
    paymentIcon: "/assets/images/paymentIcon.svg",
    vsidcopyIcon: "/assets/images/vsidcopyIcon.svg",
    markReadIcon: "/assets/images/markReadIcon.svg",
    archiveIcon: "/assets/images/archiveIcon.svg",
    notificationProfileImg: "/assets/images/notificationProfileImg.svg",
    iconCalculator: "/assets/userimages/icon-calculator.svg",
    sidebarUser: "/assets/userimages/sidebar-user.svg",
    purchaseVdo: "/assets/userimages/pur-video-icon.svg",
    purchaseRequest: "/assets/userimages/pur-reqst-icon.svg",
    chatIcon: "/assets/userimages/icon-chat.svg",
    userMessageIcon: "/assets/userimages/userMessageIcon.svg",
    userCompleteVideoIcon: "/assets/userimages/userCompleteVideoIcon.svg",
    userRevisionIcon: "/assets/userimages/userRevisionIcon.svg",
    userTitlingIcon: "/assets/userimages/userTitlingIcon.svg",
    partnerProfile: "/assets/images/partnerProfile.png",
    chatFooter: "/assets/userimages/chat-footer.svg",
    percentangeIcon: "/assets/images/percentangeIcon.svg",
    dollerIcon: "/assets/images/dollerIcon.svg",
    purchaseIconLg: "/assets/userimages/purchaseIconLg.svg",
    titlingImg: "/assets/userimages/titlingImg.png",
    paymentNoitem: "/assets/userimages/payment-noitem.svg",
    purchaseIcon: "/assets/images/purchase_icon.svg",
    arrow_long_htm: "/assets/images/arrow_long_htm.svg",
    video_pending_image: "/assets/images/video_pending_image2.svg",
    ticled_video: "/assets/images/ticled_video.svg",
    large_arrow_purple: "/assets/images/large_arrow_purple.svg",
    chart_line: "/assets/images/linechart.svg",
};
